/**
 * Config Package Entry
 *
 * Preserves the deleted src/config.ts contract verbatim so existing
 * `from './config'` / `from '../config'` imports resolve unchanged.
 */

import { env } from './env';

export { env } from './env';
export type { Env } from './env';
export { features } from './features';
export { givingUrl, givingEmbedUrl, withGivingAmount, parseGivingAmount, contactEmail, contactPhone } from './site';
export { groupingTaxonomy, socialLinks } from './content';
export type { SocialLink, SocialNetwork } from './content';

export const apiBaseUrl = env.VITE_API_BASE_URL;
export const blogName = env.VITE_BLOG_NAME;
export const blogSlug = blogName.toLowerCase().replace(/\s+/g, '-');
